export const simpleDottedBackground = `
  &::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: block;
    background-image: linear-gradient(189.86deg,#040032 45.4%,rgba(2,19,35,0) 97.36%),
    radial-gradient(121.16% 69.18% at -23.5% 43.46%, rgba(4,10,40,0.276689) 1.69%,rgba(4,10,40,0.276689) 48.79%, #09002f 77.36%,#09002f 89.93% ),
    url(/images/projects/landing/patrons/mobile/pink-mobile-patron.png);
  }
`

export const elementDottedBackground = `
  background-image: linear-gradient(189.86deg,#040032 45.4%,rgba(2,19,35,0) 97.36%),
      radial-gradient(121.16% 69.18% at -23.5% 43.46%,rgba(4,10,40,0.276689) 1.69%, rgba(4,10,40,0.276689) 48.79%,#040032 76.36%,#040032 88.93%),
      url(/images/projects/landing/patrons/mobile/pink-mobile-patron.png);
  @media (min-width: 768px) {
    background-image: linear-gradient(189.86deg, #040032 45.4%, rgba(2,19,35,0) 97.36%),
      radial-gradient(121.16% 69.18% at -23.5% 43.46%,rgba(4,10,40,0.276689) 1.69%, rgba(4,10,40,0.276689) 48.79%, #040032 77.36%, #040032 89.93% ),
      url(/images/projects/landing/patrons/desktop/pink-desktop-patron.png);
  }
`

export const dottedBackground = `
  position: relative;
  &::before {
    z-index: -1;
    position: absolute;
    right: 0;
    left: 0;
    height: 531.3px;
    display: block;
    content: "";
    background-image: linear-gradient(189.86deg,#040032 45.4%,rgba(2,19,35,0) 97.36%),
      radial-gradient(121.16% 69.18% at -23.5% 43.46%,rgba(4,10,40,0.276689) 1.69%,rgba(4,10,40,0.276689) 48.79%,#040032 77.36%,#040032 89.93% ),
      url(/images/projects/landing/patrons/mobile/pink-mobile-patron.png);
  }
  @media (min-width: 768px) {
    &::before {
      height: 1150px;
      background-image:
        linear-gradient(189.86deg,#040032 45.4%,rgba(2,19,35,0) 97.36%),
        radial-gradient(121.16% 69.18% at -23.5% 43.46%,rgba(4,10,40,0.276689) 1.69%,rgba(4,10,40,0.276689) 48.79%,#040032 77.36%,#040032 89.93% ),
        url(/images/projects/landing/patrons/desktop/pink-desktop-patron.png);
    }
  }
`
